import I18NLabels from './I18NLabels';

export default I18NLabels;
